import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { AgentCompanyListingsQuery } from 'interfaceAdapter/queries/AgentCompanyListings';
import { IPublicCompany } from 'domain/entities/Company/Company';
import { IPublicBuyer } from 'domain/entities/Buyer/Buyer';
import { useLoading } from 'application/contexts/useLoading';

export const useDashboard = () => {
    const diContainer = useContext(diContainerContext);
    const agentCompanyListingsQuery = diContainer.resolve(AgentCompanyListingsQuery);
    const { loading, setLoading } = useLoading();
    const [companies, setCompanies] = useState<IPublicCompany[]>([]);
    const [buyers, setBuyers] = useState<IPublicBuyer[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const resCompanies = await agentCompanyListingsQuery.fetchCompanies({
                limit: 4,
                sort: 'created_at',
            });
            setCompanies(resCompanies);
            const resBuyers = await agentCompanyListingsQuery.fetchBuyers({
                limit: 6,
                sort: 'created_at',
            });
            setBuyers(resBuyers);
            setLoading(false);
        };
        fetchData();
    }, []);

    return {
        loading,
        companies,
        buyers,
    };
};
